



























































































































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import { InputCode } from '@/components/molecules/InputCode'
import {
  BibliographySetDetailVolume,
  defaultSystemCode,
  SystemCode
} from '@/api'
import {
  Col,
  DataTable,
  SortColumn,
  DataTableHeader,
  defaultSortColumn
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'
import { orderBy } from 'lodash'
import { Prefix } from '@/types'

export interface BibliographyDetailVolumeTableDisplayBranchCode {
  displayBranchCode: {
    input: SystemCode
    errorMessage: string
  }
}

export const defaultBibliographyDetailVolumeTableDisplayBranchCode = (): BibliographyDetailVolumeTableDisplayBranchCode => ({
  displayBranchCode: {
    input: defaultSystemCode(),
    errorMessage: ''
  }
})

export interface BibliographyDetailVolumeTableItemRow
  extends BibliographySetDetailVolume {
  isSelected: boolean
}

export const defaultBibliographyDetailVolumeTableItemRow = (): BibliographyDetailVolumeTableItemRow => ({
  isSelected: false,
  prefix: Prefix.Real,
  bibliographyId: 0,
  collectionNo: '',
  marcNo: '',
  bibliographyContentId: 0,
  volume: '',
  volumeNumber: '',
  volumeTotal: '',
  volumeDateLabel: '',
  volumeSpecial: '',
  displayContent: '',
  continueAndLookCode: defaultSystemCode(),
  collectionsStatus: defaultSystemCode(),
  continuationStatusName: '',
  shelfCount: 0,
  holdingCount: 0,
  orderCount: 0,
  reserveCount: 0,
  revision: 0
})

export interface BibliographyDetailVolumeTableItem {
  rows: BibliographyDetailVolumeTableItemRow[]
  sortColumn: SortColumn
  sortedRows: () => BibliographyDetailVolumeTableItemRow[]
  selectedRow: () => BibliographyDetailVolumeTableItemRow
  select: (index: number) => void
}

export const defaultBibliographyDetailVolumeTableItem = (): BibliographyDetailVolumeTableItem => ({
  rows: [],
  sortColumn: defaultSortColumn(),
  sortedRows() {
    if (this.sortColumn.name) {
      return orderBy<BibliographyDetailVolumeTableItemRow>(
        this.rows,
        (item: BibliographyDetailVolumeTableItemRow) => {
          const propertyValue =
            // eslint-disable-next-line standard/computed-property-even-spacing
            item[
              this.sortColumn.name as keyof BibliographyDetailVolumeTableItemRow
            ]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortColumn.order as 'asc' | 'desc'[]
      )
    }

    return this.rows
  },
  selectedRow() {
    return (
      this.rows.find(row => row.isSelected) ??
      defaultBibliographyDetailVolumeTableItemRow()
    )
  },
  select(bibliographyId: number) {
    this.rows.forEach(
      row => (row.isSelected = row.bibliographyId === bibliographyId)
    )
  }
})

@Component({
  components: {
    RecycleScroller,
    DataTableHeader,
    DataTable,
    InputCode
  }
})
export default class BibliographyDetailVolumeTable extends DataTable {
  @PropSync('tableItem', {
    type: Object,
    required: true
  })
  volumeList!: BibliographyDetailVolumeTableItem

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Object,
    required: true
  })
  displayBranchCode!: BibliographyDetailVolumeTableDisplayBranchCode

  get showCols(): Col[] {
    return [
      {
        width: 26,
        items: [
          {
            name: 'radio',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'volume',
            headerText: '巻',
            sortable: true,
            sortOrder:
              this.volumeList.sortColumn.name === 'volume'
                ? this.volumeList.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'volumeNumber',
            headerText: '号',
            sortable: true,
            sortOrder:
              this.volumeList.sortColumn.name === 'volumeNumber'
                ? this.volumeList.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'volumeTotal',
            headerText: '通巻',
            sortable: true,
            sortOrder:
              this.volumeList.sortColumn.name === 'volumeTotal'
                ? this.volumeList.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'volumeDateLabel',
            headerText: '年月日号',
            sortable: true,
            sortOrder:
              this.volumeList.sortColumn.name === 'volumeDateLabel'
                ? this.volumeList.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'volumeSpecial',
            headerText: '特別区分',
            sortable: true,
            sortOrder:
              this.volumeList.sortColumn.name === 'volumeSpecial'
                ? this.volumeList.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '30',
        resizable: true,
        items: [
          {
            name: 'displayContent',
            headerText: '内容',
            sortable: true,
            sortOrder:
              this.volumeList.sortColumn.name === 'displayContent'
                ? this.volumeList.sortColumn.order
                : ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'shelfCount',
            headerText: '貸出可',
            align: 'right'
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'holdingCount',
            headerText: '所蔵',
            align: 'right'
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'orderCount',
            headerText: '発注',
            align: 'right'
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        items: [
          {
            name: 'reserveCount',
            headerText: '予約',
            align: 'right'
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        items: [
          {
            name: 'collectionsStatus',
            headerText: '資料状態'
          }
        ]
      },
      {
        width: 70,
        resizable: true,
        items: [
          {
            name: 'action',
            headerText: '',
            align: 'center'
          }
        ]
      }
    ]
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSortRows(sortColumn: SortColumn): void {
    this.volumeList.sortColumn = sortColumn
  }

  @Emit('link')
  onClickLink(bibliographyId: number): number {
    return bibliographyId
  }

  @Emit('volume')
  onClickVolume(bibliographyId: number): number {
    return bibliographyId
  }

  @Emit('toggle')
  onClickToggle(): SystemCode {
    return this.displayBranchCode.displayBranchCode.input
  }

  @Emit('download')
  onClickDownload(): void {}
}
